import { useMemo } from 'react'
import dayjs from 'dayjs'
import { useCountdownObj } from 'hooks/useCountdown'

const defaultOnDone = () => undefined

const useEndOfUTCDayCountdown = (onDone = defaultOnDone) => {
  const resetTime = useMemo(() => dayjs().utc().endOf('day').toDate().getTime(), [])
  return useCountdownObj(resetTime, onDone)
}

export default useEndOfUTCDayCountdown
